import { Screen } from "../../api/ApiClient";
import { ScreenMapper } from "./ScreenMapper";

export class ScreenMapperRegistry {

    private readonly mappers = new Map<Screen["type"], ScreenMapper>();

    register(mapper: ScreenMapper): void {

        this.mappers.set(mapper.type, mapper);

    }

    get(type: Screen["type"]): ScreenMapper {

        const mapper = this.mappers.get(type);

        if (!mapper) {

            throw new Error(
                `Unknown ScreenMapper: ${type}`
            );

        }

        return mapper;

    }

}